{
  "accountInformation": "معلومات الحساب",
  "accountStatus": "حالة الحساب",
  "active": "نشط",
  "admin": "الإدارة",
  "adminBadge": "مسؤول",
  "adminPrivileges": "صلاحيات المسؤول",
  "aiDefaultHelp": "كيف يمكنني مساعدتك اليوم؟",
  "aiDepositHelp": "اسأل عن مشاكل الإيداع أو التأخير أو التأكيدات.",
  "aiKycHelp": "اسأل عن التحقق من الهوية ومتطلبات المستندات.",
  "aiLoginHelp": "اسأل عن مشاكل تسجيل الدخول أو كلمة المرور أو الوصول للحساب.",
  "aiP2pHelp": "اسأل عن طلبات P2P أو النزاعات أو مشاكل الدفع.",
  "aiSupportAssistant": "مساعد الدعم الذكي",
  "aiSupportAssistantText": "احصل على إجابات فورية للأسئلة الشائعة، أو أنشئ تذكرة لفريقنا.",
  "aiWithdrawHelp": "اسأل عن حالة السحب أو التأخير أو المتطلبات.",
  "askAiSupport": "اسأل الدعم الذكي",
  "bio": "نبذة مهنية",
  "capital": "رأس المال",
  "changeImage": "تغيير الصورة",
  "cnicBack": "بطاقة الهوية (الخلف)",
  "cnicFront": "بطاقة الهوية (الأمام)",
  "connectedWallet": "المحفظة المتصلة",
  "country": "الدولة",
  "createSupportTicket": "إنشاء تذكرة دعم",
  "describeIssue": "صف مشكلتك",
  "disabled": "معطل",
  "displayName": "اسم العرض",
  "editProfile": "تعديل الملف الشخصي",
  "email": "البريد الإلكتروني",
  "emailOtpSendFailed": "فشل إرسال رمز التحقق. يرجى المحاولة مرة أخرى.",
  "emailOtpSent": "تم إرسال رمز التحقق إلى بريدك الإلكتروني.",
  "emailVerification": "التحقق من البريد الإلكتروني",
  "emailVerifiedSuccessfully": "تم توثيق البريد الإلكتروني بنجاح.",
  "enabled": "مفعل",
  "enterEmailOtp": "أدخل رمز التحقق",
  "enterOtpFirst": "يرجى إدخال رمز التحقق أولاً.",
  "estimatedProfit": "الربح المقدر",
  "faceVerificationNotAutomated": "التحقق التلقائي بالصورة الشخصية غير متاح بعد. سيتم مراجعة الصورة التي قمت بتحميلها يدويًا كجزء من الموافقة على KYC.",
  "failedLoadNotifications": "فشل تحميل الإشعارات.",
  "failedMarkAllRead": "فشل تحديد الكل كمقروء.",
  "failedMarkRead": "فشل التحديد كمقروء.",
  "failedSubmitTicket": "فشل إرسال التذكرة.",
  "fullLegalName": "الاسم القانوني الكامل",
  "fullName": "الاسم الكامل",
  "idNumber": "رقم الهوية",
  "imagePreview": "معاينة الصورة",
  "imageTooLarge": "الحد الأقصى لحجم الصورة هو 5 ميجابايت.",
  "inactive": "غير نشط",
  "invalidImageType": "يُسمح فقط بصور JPG وPNG وWEBP.",
  "invalidOtp": "الرمز غير صحيح أو منتهي الصلاحية. يرجى المحاولة مرة أخرى.",
  "joinedDate": "تاريخ الانضمام",
  "kycStatus": "حالة التحقق (KYC)",
  "kycSubmissionFailed": "فشل إرسال طلب التحقق من الهوية.",
  "kycSubmittedSuccessfully": "تم إرسال طلب التحقق من الهوية بنجاح.",
  "lastLogin": "آخر تسجيل دخول",
  "liquidationZone": "منطقة التصفية",
  "loadingNotifications": "جارٍ تحميل الإشعارات...",
  "loadingProfile": "جارٍ تحميل الملف الشخصي...",
  "markAllRead": "تحديد الكل كمقروء",
  "mobileNumberCountryCode": "رقم الجوال (مع رمز الدولة)",
  "network": "الشبكة",
  "noNotifications": "لا توجد إشعارات بعد.",
  "noUtilityToolsFound": "لم يتم العثور على أدوات مساعدة.",
  "notSubmitted": "لم يتم الإرسال",
  "notVerifiedEmail": "غير موثق",
  "openTool": "فتح الأداة",
  "owner": "المالك",
  "ownerBadge": "المالك",
  "ownerControlCenter": "مركز تحكم المالك",
  "passportNationalId": "جواز السفر / الهوية الوطنية",
  "pending": "قيد الانتظار",
  "phoneNumber": "رقم الهاتف",
  "positionSize": "حجم المركز",
  "positionValue": "قيمة المركز",
  "processing": "جاري المعالجة...",
  "profileImage": "صورة الملف الشخصي",
  "profileSecurity": "أمان الملف الشخصي",
  "profileSubtitle": "إدارة الملف الشخصي، التحقق KYC، المحفظة وإعدادات الأمان.",
  "profileTitle": "الملف الشخصي",
  "profileUpdateFailed": "فشل تحديث الملف الشخصي",
  "profileUpdatedSuccessfully": "تم تحديث الملف الشخصي بنجاح",
  "read": "مقروء",
  "rejected": "مرفوض",
  "removeImage": "إزالة الصورة",
  "required": "مطلوب",
  "riskAmount": "مبلغ المخاطرة",
  "riskPercent": "نسبة المخاطرة",
  "riskPositionCalculator": "حاسبة المخاطر والمركز",
  "role": "الدور",
  "saveProfile": "حفظ الملف الشخصي",
  "savingProfile": "جارٍ حفظ الملف الشخصي...",
  "securityLevel": "مستوى الأمان",
  "selfieVerification": "التحقق بالصورة الشخصية",
  "sendEmailOtp": "إرسال رمز التحقق عبر البريد الإلكتروني",
  "sendingEmailOtp": "جارٍ الإرسال...",
  "serverError": "خطأ في الخادم.",
  "sessionActive": "الجلسة نشطة",
  "sessionExpired": "انتهت الجلسة. الرجاء تسجيل الدخول مرة أخرى.",
  "subject": "الموضوع",
  "submitKyc": "إرسال طلب التحقق من الهوية",
  "submitTicket": "إرسال التذكرة",
  "submittingKyc": "جارٍ إرسال طلب التحقق من الهوية...",
  "supportBadge": "الدعم",
  "supportRequiredFields": "الموضوع والوصف مطلوبان.",
  "telegram": "تيليجرام",
  "ticketSubmittedSuccessfully": "تم إرسال التذكرة بنجاح.",
  "tools": "الأدوات",
  "totalNotifications": "إجمالي الإشعارات",
  "twoFactorStatus": "المصادقة الثنائية",
  "uid": "معرف المستخدم",
  "unread": "غير مقروء",
  "updateSuccessful": "تم تحديث الملف الشخصي بنجاح.",
  "uploadBackSide": "تحميل الجانب الخلفي",
  "uploadDocument": "تحميل المستند",
  "uploadFrontSide": "تحميل الجانب الأمامي",
  "uploadIdDocument": "يرجى تحميل مستند هوية.",
  "uploadImage": "رفع صورة",
  "uploadSelfie": "تحميل الصورة الشخصية",
  "uploadSelfieRequired": "يرجى تحميل صورة شخصية قبل الإرسال.",
  "user": "مستخدم",
  "userId": "معرف المستخدم",
  "userProfile": "الملف الشخصي",
  "utilityTools": "الأدوات المساعدة",
  "verified": "موثق",
  "verifiedBadge": "موثق",
  "verifiedEmail": "موثق",
  "verifyEmailFirst": "يرجى توثيق بريدك الإلكتروني أولاً.",
  "verifyingEmailOtp": "جارٍ التحقق...",
  "walletAddress": "عنوان المحفظة",
  "walletOrderTxOptional": "عنوان المحفظة أو معرّف الطلب أو معرّف المعاملة (اختياري)",
  "writeProfessionalBio": "اكتب نبذة احترافية قصيرة عن نفسك"
}